// ==================== ENUMS ====================

export enum GeofenceShapeType {
  POINT_RADIUS = 'POINT_RADIUS',
  POLYGON = 'POLYGON',
}

// ==================== SHARED ====================

export interface LatLng {
  lat: number;
  lng: number;
}

// ==================== GEOFENCE CATEGORY ====================

export interface GeofenceCategory {
  geofenceCategoryId: string;
  name: string;
  description?: string | null;
  icon?: string | null;
  color?: string | null;
  isActive: boolean;
  isGlobal: boolean;
  sortOrder: number;
  organizationId?: string | null;
  createdAt?: string | Date;
  updatedAt?: string | Date;
}

export interface GeofenceCategoryCreateInput {
  name: string;
  description?: string;
  icon?: string;
  color?: string;
  isActive?: boolean;
  sortOrder?: number;
}

export interface GeofenceCategoryUpdateInput {
  geofenceCategoryId: string;
  name?: string;
  description?: string;
  icon?: string;
  color?: string;
  isActive?: boolean;
  sortOrder?: number;
}

// ==================== GEOFENCE ====================

export interface GeofenceShape {
  type: GeofenceShapeType;
  center?: LatLng | null;
  radiusMeters?: number | null;
  polygonCoordinates?: LatLng[] | null;
}

export interface Geofence {
  geofenceId: string;
  name: string;
  description?: string | null;
  shape: GeofenceShape;
  color?: string | null;
  isActive: boolean;
  geofenceCategoryId: string;
  category?: GeofenceCategory | null;
  organizationId: string;
  projectId?: string | null;
  project?: { projectId: string; name: string } | null;
  warehouseId?: string | null;
  warehouse?: { warehouseId: string; name: string } | null;
  createdAt?: string | Date;
  updatedAt?: string | Date;
}

export interface GeofenceCreateInput {
  name: string;
  description?: string;
  geofenceCategoryId: string;
  shapeType: GeofenceShapeType;
  centerPoint?: LatLng | null;
  radiusMeters?: number | null;
  polygonCoordinates?: LatLng[] | null;
  color?: string;
  isActive?: boolean;
  projectId?: string;
  warehouseId?: string;
}

export interface GeofenceUpdateInput {
  geofenceId: string;
  name?: string;
  description?: string;
  geofenceCategoryId?: string;
  /** Provide to switch between POINT_RADIUS and POLYGON. Required matching shape data. */
  shapeType?: GeofenceShapeType;
  centerPoint?: LatLng | null;
  radiusMeters?: number | null;
  polygonCoordinates?: LatLng[] | null;
  color?: string;
  isActive?: boolean;
  projectId?: string;
  warehouseId?: string;
}

export interface GeofenceFilterInput {
  geofenceCategoryId?: string;
  projectId?: string;
  warehouseId?: string;
  isActive?: boolean;
}
